import styled from '@emotion/styled/macro'
import { Box } from '@mui/material'
import theme from 'theme'

export const DashboardContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isEmpty'
})<{ isEmpty?: boolean }>`
  display: flex;
  align-items: ${({ isEmpty }) => (isEmpty ? 'stretch' : 'flex-start')};
  gap: ${theme.spacing.medium}px;
  padding: ${theme.spacing.medium}px;
  /* Offset the 20px scrollbar gutter reserved by .content-wrapper so the
     visible right gap matches the left (medium) padding in both
     scrollbar/no-scrollbar states. Without this, the right edge reads as
     padding + gutter while the left is just padding. */
  padding-right: calc(${theme.spacing.medium}px - 20px);
  width: 100%;
  box-sizing: border-box;
  ${({ isEmpty }) => (isEmpty ? 'min-height: 100%;' : '')}
`

export const LeftColumn = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.medium}px;
  width: 432px;
  min-width: 432px;
  overflow: hidden;
`

export const RightColumn = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.medium}px;
  flex: 1;
  min-width: 0;
`

export const RightTopRow = styled(Box)`
  display: flex;
  gap: ${theme.spacing.medium}px;
  /* Block the row from establishing a min-content size larger than the
     RightColumn — otherwise zoom-in narrowing the column pushes the
     Benchmarking sibling past the viewport edge instead of letting both
     cards reflow within the available width. */
  min-width: 0;
  width: 100%;
`

export const SectionCard = styled(Box)`
  background: ${theme.colors.surfaceContainerBackground};
  border-radius: ${theme.attributes.borderRadius.tertiary};
  overflow: hidden;
`

export const CategoryDashboardHeader = styled(Box)`
  background: ${theme.colors.surfaceContainerBackground};
  border-bottom: 1px solid ${theme.colors.borderMedium};
  padding: ${theme.spacing.small}px ${theme.spacing.medium}px ${theme.spacing.medium}px;

  .header-content {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    .header-left {
      display: flex;
      flex-direction: column;
      gap: ${theme.spacing.small}px;

      .breadcrumbs {
        display: flex;
        align-items: center;
        gap: ${theme.spacing.xSmall}px;
        height: 20px;

        .breadcrumb-link {
          font-family: ${theme.typography.fontFamily.primary};
          font-weight: ${theme.typography.fontWeight.bold};
          font-size: ${theme.typography.fontSize.medium};
          color: ${theme.colors.dropdownLabel};
          letter-spacing: 0.5px;
          line-height: 18px;
          cursor: pointer;

          &:hover {
            color: ${theme.colors.cta};
          }

          html[data-theme='light'] &:not(:hover) {
            color: #6b6b76;
          }
        }

        .breadcrumb-separator {
          font-family: ${theme.typography.fontFamily.primary};
          font-weight: ${theme.typography.fontWeight.bold};
          font-size: ${theme.typography.fontSize.medium};
          color: ${theme.colors.dropdownLabel};
          letter-spacing: 0.1px;
          line-height: 18px;
        }
      }

      .page-title {
        font-family: ${theme.typography.fontFamily.primary};
        font-weight: ${theme.typography.fontWeight.bold};
        font-size: ${theme.typography.fontSize.epic};
        color: ${theme.colors.menuItemText};
        line-height: 48px;
      }
    }

    .header-right {
      padding-top: ${theme.spacing.xSmall}px;

      .export-button {
        width: 48px;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: ${theme.attributes.borderRadius.tertiary};
        border: 1px solid ${theme.colors.strokePrimary};
        cursor: pointer;

        &:hover {
          border-color: ${theme.colors.cta};

          svg path {
            stroke: ${theme.colors.cta};
          }
        }
      }
    }
  }
`
